// sessionStorage

export const getSession = key => JSON.parse(sessionStorage.getItem(key))

export const setSession = (key, value) =>
  sessionStorage.setItem(key, JSON.stringify(value))

export const removeSession = key => sessionStorage.removeItem(key)

// localStorage

export const getStorage = key => JSON.parse(localStorage.getItem(key))

export const setStorage = (key, value) =>
  localStorage.setItem(key, JSON.stringify(value))

export const removeStorage = key => localStorage.removeItem(key)

// initial react chart config for session storage

const _endDate = new Date()
const _startDate = new Date()
_startDate.setDate(_startDate.getDate() - 6)
const start = _startDate.toISOString().split('T')[0]
const end = _endDate.toISOString().split('T')[0]

const startDay = _startDate.toISOString().split('T')[0] + 'T00:00:00'
const endDay =
  `${_endDate.getFullYear()}-` +
  `${String(_endDate.getMonth() + 1).padStart(2, '0')}-` +
  `${String(_endDate.getDate()).padStart(2, '0')}T` +
  `${String(_endDate.getHours()).padStart(2, '0')}:00:00`

const _endDateMonth = new Date()
const _startDateMonth = new Date()

// Start: 1. Tag des letzten Monats
_startDateMonth.setMonth(_startDateMonth.getMonth() - 1)
_startDateMonth.setDate(1)

// Ende: letzter Tag des letzten Monats
_endDateMonth.setDate(0)
_endDateMonth.setHours(23, 59, 59, 999)

const startMonth = _startDateMonth.toISOString().split('T')[0]
const endMonth = _endDateMonth.toISOString().split('T')[0]

export const initialChartConfig = {
  chartType: 'ColumnChart',
  diagnosis: false,
  granularity: 'm',
  fromDate: start,
  isStacked: true,
  showSettings: false,
  toDate: end,
  fromDateMonth: startMonth,
  toDateMonth: endMonth,
  fromDateDay: startDay,
  toDateDay: endDay,
}
